/**
 * snap — pure geometry for Windows 11-style window snapping.
 *
 * The "stage" is the area windows live in: full viewport width, height minus the
 * taskbar. Window coordinates are stage coordinates (stage sits at viewport
 * 0,0), so zone bounds double as fixed-position preview rects.
 */

export const TASKBAR_H = 48;
export const SNAP_EDGE = 24; // px from an edge that triggers a snap

export const computeStage = () => ({
  w: typeof window !== "undefined" ? window.innerWidth : 1280,
  h: typeof window !== "undefined" ? Math.max(0, window.innerHeight - TASKBAR_H) : 720,
});

// Which snap zone (if any) does the cursor fall into?
export const detectZone = (cx, cy, stage, edge = SNAP_EDGE) => {
  const left = cx <= edge;
  const right = cx >= stage.w - edge;
  const top = cy <= edge;
  const bottom = cy >= stage.h - edge;
  if (top && left) return "tl";
  if (top && right) return "tr";
  if (bottom && left) return "bl";
  if (bottom && right) return "br";
  if (left) return "left";
  if (right) return "right";
  if (top) return "maximize";
  return null;
};

// Pixel bounds for a zone (null for "maximize", which uses the maximize action).
export const zoneBounds = (zone, stage) => {
  const hw = Math.round(stage.w / 2);
  const hh = Math.round(stage.h / 2);
  switch (zone) {
    case "left":
      return { x: 0, y: 0, w: hw, h: stage.h };
    case "right":
      return { x: hw, y: 0, w: stage.w - hw, h: stage.h };
    case "tl":
      return { x: 0, y: 0, w: hw, h: hh };
    case "tr":
      return { x: hw, y: 0, w: stage.w - hw, h: hh };
    case "bl":
      return { x: 0, y: hh, w: hw, h: stage.h - hh };
    case "br":
      return { x: hw, y: hh, w: stage.w - hw, h: stage.h - hh };
    case "maximize":
      return { x: 0, y: 0, w: stage.w, h: stage.h };
    default:
      return null;
  }
};

// The layout choices offered by the Snap Layouts flyout (maximize button).
export const SNAP_LAYOUTS = ["left", "right", "tl", "tr", "bl", "br"];
